import { render, staticRenderFns } from "./familymembers.vue?vue&type=template&id=1acb825e&scoped=true"
import script from "./familymembers.vue?vue&type=script&lang=js"
export * from "./familymembers.vue?vue&type=script&lang=js"
import style0 from "./familymembers.vue?vue&type=style&index=0&id=1acb825e&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1acb825e",
  null
  
)

export default component.exports